module.exports = __webpack_public_path__ + "img/promotion4_1.ce420a6a.jpg";